import $ from 'jquery';
import _ from 'lodash';

import 'slick-carousel';
import {isMobile} from '../utilities';

class Carousel {
  constructor(element, i){
    this.$el = $(element);
    this.els = {
      component: this.$el,
      slides : this.$el.find('.slides'),
      counter : this.$el.find('.slide-count')
    };
    this.slickOptions = {
      arrows:true,
      infinite:true,
      nextArrow: '<div class="carousel-arrow carousel-arrow-next icon-right"></div>',
      prevArrow: '<div class="carousel-arrow carousel-arrow-prev icon-left"></div>',
      dots: true,
      slidesToShow:1,
      slidesToScroll:1,
      waitForAnimate:false,
      centerMode: true,
      centerPadding: '119px',
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            centerPadding: '8.3vw',
          }
        },
        {
          breakpoint: 768,
          settings: {
            centerMode: false,
            arrows:false,
          }
        }
      ]
    };

    if(this.$el.hasClass('home-carousel') || this.$el.hasClass('split')){
      this.slickOptions.centerMode = false;
      this.slickOptions.centerPadding = 0;
    }

    if(this.$el.hasClass('cards')) {
      this.slickOptions.slidesToShow = 3;
      this.slickOptions.dots = false;
      this.slickOptions.responsive[1].settings.slidesToShow = 1;
      this.slickOptions.responsive[1].settings.centerMode = true;
      this.slickOptions.responsive[1].settings.centerPadding = '40px';
      this.slickOptions.responsive[1].settings.infinite = false;
      this.slickOptions.responsive[1].settings.dots = true;
      this.slickOptions.responsive[1].settings.appendDots = this.$el;
    }

    if(this.$el.hasClass('press-clip')) {
      this.slickOptions.centerPadding = '0px';
      this.slickOptions.responsive[0].settings.centerPadding = '0px';
      this.slickOptions.dots = false;
      this.slickOptions.asNavFor = '.press-clip-thumbnail .carousel-wrapper .slides';
    }

    if(this.$el.hasClass('press-clip-thumbnail')) {
      this.slickOptions.centerPadding = '0px';
      this.slickOptions.centerMode = false;
      this.slickOptions.vertical = true;
      this.slickOptions.dots = false;
      this.slickOptions.slidesToShow = 3;
      this.slickOptions.asNavFor = '.press-clip .carousel-wrapper .slides';
      this.slickOptions.focusOnSelect = true;
      this.slickOptions.nextArrow = '<div class="carousel-arrow carousel-arrow-next icon-down"></div>';
      this.slickOptions.prevArrow = '<div class="carousel-arrow carousel-arrow-prev icon-up"></div>';
      this.slickOptions.responsive[0].settings.centerPadding = '0px';
      this.slickOptions.responsive[0].settings.slidesToShow = 3;
      this.slickOptions.responsive[1].settings.vertical = false;
      this.slickOptions.responsive[1].settings.arrows = true;
      this.slickOptions.responsive[1].settings.nextArrow = '<div class="carousel-arrow carousel-arrow-next icon-right"></div>';
      this.slickOptions.responsive[1].settings.prevArrow = '<div class="carousel-arrow carousel-arrow-prev icon-left"></div>';
    }

    this.updateSlideCount();
    this.buildCarousel();
  }

  updateSlideCount(){
    this.els.slides.on('init reInit afterChange', function(event,slick, currentSlide) {
      let i = (currentSlide ? currentSlide : 0) + 1;
      this.els.counter.text('Page: ' + i + '/' + slick.slideCount);
    }.bind(this));
  }

  buildCarousel(){
    this.els.slides.slick(this.slickOptions);

    let obj = this;
    this.els.slides.on({
      beforeChange: function(e, slick, currentSlide, nextSlide) {
        obj.beforeChangeAction(currentSlide, nextSlide);
      }
    });

    this.initAutoplayVideos();

    if (this.$el.hasClass('strip') || this.$el.hasClass('cards')) {
      setTimeout(this.setHeight.bind(this), 500)
      $(window).on('resize', _.debounce(() => {
        this.setHeight();
      }, 400));
    }
  }

  setHeight() {
    let maxHeight = 0;
    this.els.slides.find('.slide').each((index, value) => {
      let $info = $(value).find('.info');
      if ($info.length > 0) {
        let slideHeight = $(value).outerHeight();
        let slideInfoHeight = $info.outerHeight();
        let slideInfoTop = $info.position().top;
        if (slideInfoHeight) slideHeight += slideInfoHeight - (slideHeight - slideInfoTop);
        if (maxHeight < slideHeight) maxHeight = slideHeight;
      }
    });
    if (maxHeight) this.$el.height(maxHeight + 'px');
  }

  initAutoplayVideos() {
    // if(!isMobile()) {
    //   var $firstSlide = this.els.slides.find('.slide').first();
    //   if($firstSlide.find('.background').hasClass('show-video')) {
    //     videojs($firstSlide.find('.video-js').attr('id')).play();
    //   }
    // }
  }

  beforeChangeAction(currentSlide, nextSlide) {
    if(!isMobile()) {
      var $currSlide = this.els.slides.find('.slick-slide[data-slick-index="' + currentSlide.toString() + '"]');
      var $nextSlide = this.els.slides.find('.slick-slide[data-slick-index="' + nextSlide.toString() + '"]');
      this.beforeChangeVideoSlide($currSlide, $nextSlide);
    }
  }

  beforeChangeVideoSlide($currSlide, $nextSlide){
    if($currSlide.find('.background').hasClass('show-video')) {
      // videojs($currSlide.find('.video-js').attr('id')).pause();
    }
    if($nextSlide.find('.background').hasClass('show-video')) {
      // videojs($nextSlide.find('.video-js').attr('id')).play();
    }
  }
}

if($('.carousel-component').length) {
  $('.carousel-component').each(function(index,element) {
    new Carousel(element, index);
  });

  // Fix card text.
  $(window).on('load', () => {
    window.dispatchEvent(new Event('resize'));
  })
}
